module.exports = __webpack_public_path__ + "img/9.f1bbf6da.png";